import React from 'react';
import { connect } from 'react-redux';

import MARITAL_STATUSES from 'src/constants/Options';
import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { getOptionLabel, display } from 'src/utils/Utils';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { withTranslation } from "react-i18next"

const MaritalStatusSectionShow = ({ employee, t }) => (
  <div>
    <table className={tableStyles.mTablePersonal}>
      <tbody>
        <tr>
          <th>{t('features.Employees.showEmployee.spouse_information')}:</th>
          <td>{display(getOptionLabel(employee.maritalStatus ? '1' : '0')(MARITAL_STATUSES))}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

export default connect(state => ({
  employee: selector(getItem(REDUCER_NAME, state), 'employee')
}))(withTranslation()(MaritalStatusSectionShow));
